export default __webpack_public_path__ + "static/media/I0002.b0e8bcd1.png";